import { makeStyles } from '@material-ui/styles'

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(3),
  },
  fieldGroup: {
    marginBottom: theme.spacing(1),
    marginTop: theme.spacing(1),
  },
  item: {
    marginBottom: theme.spacing(2),
    paddingLeft: '10px',
    paddingRight: '10px',
  },
  inputForm: {
    height: theme.spacing(7),
  },
  divider: {
    marginBottom: theme.spacing(1),
    marginTop: theme.spacing(1),
  },
  botaoAddFiliacao: {
    marginBottom: theme.spacing(2),
  },
  textoConfiguracao: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
  corpoFormulario: {
    margin: theme.spacing(2),
  },
}))

export default useStyles
